"use strict";
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-duplicates */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var prefixCls = 'tce-table';
var Filter = function (_a) {
    var onFilter = _a.onFilter, filterValue = _a.filterValue, onReset = _a.onReset, options = _a.options, paginationOpts = _a.paginationOpts;
    var _b = paginationOpts || {}, _c = _b.resetText, resetText = _c === void 0 ? 'Reset' : _c, _d = _b.sureText, sureText = _d === void 0 ? 'OK' : _d;
    var _e = (0, react_1.useState)(filterValue), filter = _e[0], setFilter = _e[1];
    var _f = (0, react_1.useState)(''), search = _f[0], setSearch = _f[1];
    var filterOptions = options.filter(function (item) {
        if (!search)
            return true;
        return item.toLowerCase().includes(search.toLowerCase());
    });
    (0, react_1.useEffect)(function () {
        setFilter(filterValue);
    }, [filterValue]);
    return (react_1.default.createElement("div", { className: "".concat(prefixCls, "__filter"), onClick: function (e) { return e.stopPropagation(); } },
        react_1.default.createElement("div", { className: "".concat(prefixCls, "__filter-searchbox") },
            react_1.default.createElement(antd_1.Input, { className: "".concat(prefixCls, "__searchbox-input"), value: search, onChange: function (v) {
                    setSearch(v.target.value);
                } }),
            react_1.default.createElement("div", { className: "".concat(prefixCls, "__searchbox-icon") })),
        react_1.default.createElement(antd_1.Checkbox.Group, { className: "".concat(prefixCls, "__checkbox"), style: { width: '100%' }, value: filter, options: filterOptions, onChange: function (values) {
                setFilter(values);
            } }),
        react_1.default.createElement("div", { className: "".concat(prefixCls, "__filter-ft") },
            react_1.default.createElement(antd_1.Button, { size: "small", onClick: function (e) {
                    onReset();
                    e.stopPropagation();
                } }, resetText),
            react_1.default.createElement(antd_1.Button, { size: "small", type: "primary", onClick: function (e) {
                    onFilter(filter);
                    e.stopPropagation();
                } }, sureText))));
};
var Table = function (props) {
    var allTableData = props.allTableData, row = props.row, col = props.col, _a = props.className, className = _a === void 0 ? '' : _a, _b = props.tableMaxHeight, tableMaxHeight = _b === void 0 ? 500 : _b, _c = props.tableHeight, tableHeight = _c === void 0 ? 500 : _c, filerOb = props.filerOb, setFilterOb = props.setFilterOb, paginationOpts = props.paginationOpts, setPageIndex = props.setPageIndex;
    var classes = (0, classnames_1.default)(prefixCls, className);
    var _d = (0, react_1.useState)({}), show = _d[0], setShow = _d[1];
    (0, react_1.useEffect)(function () {
        if (!show)
            return;
        function handleClick(e) {
            setShow({});
        }
        window.addEventListener('click', handleClick);
        return function () {
            window.removeEventListener('click', handleClick);
        };
    }, []);
    var getOptions = function (row, key) {
        var cpuVendors = row.flatMap(function (item) { var _a; return (_a = item.data.find(function (d) { return d.key === key; })) === null || _a === void 0 ? void 0 : _a.text; });
        var uniqueArray = cpuVendors.filter(function (item, index) { return cpuVendors.indexOf(item) === index; });
        return uniqueArray;
    };
    var htmlText = function (text) {
        return react_1.default.createElement("div", { className: "text", dangerouslySetInnerHTML: { __html: text } });
    };
    return (react_1.default.createElement("div", { className: classes },
        react_1.default.createElement("div", { style: { maxHeight: tableMaxHeight }, className: "".concat(prefixCls, "-scroll") },
            react_1.default.createElement("table", null,
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null, col.map(function (item, index) {
                        var _a;
                        var _b, _c, _d;
                        return (react_1.default.createElement("th", { className: (_b = item.className) !== null && _b !== void 0 ? _b : undefined, key: index, onClick: function (e) {
                                if (item.filter) {
                                    setShow(function (show) {
                                        var _a;
                                        return (_a = {}, _a[index] = !show[index], _a);
                                    });
                                }
                                e.stopPropagation();
                            } },
                            react_1.default.createElement("div", { className: "".concat(prefixCls, "__content") },
                                react_1.default.createElement("div", { className: "".concat(prefixCls, "__text") }, item.text),
                                item.filter && (react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(prefixCls, "__filter-icon"), (_a = {}, _a["".concat(prefixCls, "__filter-icon-selected")] = !!((_c = filerOb[index]) === null || _c === void 0 ? void 0 : _c.length), _a)) })),
                                item.filter && show[index] && (react_1.default.createElement(Filter, { paginationOpts: paginationOpts, filterValue: (_d = filerOb[index]) !== null && _d !== void 0 ? _d : [], options: getOptions(allTableData, item.key), onFilter: function (values) {
                                        var _a;
                                        setFilterOb(__assign(__assign({}, filerOb), (_a = {}, _a[index] = values, _a)));
                                        setPageIndex(1);
                                        setShow({});
                                    }, onReset: function () {
                                        var _a;
                                        setFilterOb(__assign(__assign({}, filerOb), (_a = {}, _a[index] = [], _a)));
                                        setPageIndex(1);
                                        setShow({});
                                    } })))));
                    }))),
                react_1.default.createElement("tbody", { style: { maxHeight: tableHeight } }, row.map(function (item, index) { return (react_1.default.createElement("tr", { key: index }, item.data.map(function (item2, index2) {
                    var _a;
                    return (react_1.default.createElement("td", { className: (_a = item2.className) !== null && _a !== void 0 ? _a : undefined, key: index2 }, item2.text.length > 50 ? (react_1.default.createElement(antd_1.Tooltip, { title: htmlText(item2.text) }, htmlText(item2.text))) : (htmlText(item2.text))));
                }))); }))))));
};
exports.default = Table;
//# sourceMappingURL=Table.js.map